import { useMemo } from 'react'

import { useLanguages } from './use-languages.hook'
import { ISortSelectOption } from 'src/components/filter/types/filter.types'

const useLanguagesSelectionOption = () => {
  const { data: items } = useLanguages()

  const selectValues = useMemo(() => {
    const selectionValues: ISortSelectOption[] = items
      ? items?.data.map(({ code, name }) => ({
          label: name,
          value: code,
        }))
      : [
          {
            label: 'English',
            value: 'en',
          },
        ]

    return selectionValues
  }, [items])

  return { selectName: 'languages-filter-title.v', queryParamName: 'locale', items: selectValues }
}

export { useLanguagesSelectionOption }
